import React, { useState } from 'react';
import Select from 'react-select'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel
} from '@chakra-ui/react';
import './Payroll.css';

function Payroll(props) {
  const { closeDrawer } = props;

  const handleOnClose = () => {
    closeDrawer();
  };

  // custom style for lookup
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
  }
  const [formData, setFormData] = useState(
    {
      // employeeName: "",
      // joiningForm: "",
      // email: "",
      // currency: "",
      // taxCode: "",
      // irdNumber: "",
      // date: "",
      // street: "",
      // state: "",
      // city: "",
      // pinCode: "",
      // country: "",
      // dob: "",
      // otherContactDetail: "",
      // startDate: "",
      // bank: "",
      // branch: "",
      // phone: "",
      // rate: "",
      // timesheetLink: "",
      // employeeStatus: "",
      // worksheetLink: "",
      // vechileJobLink: "",
      // driver:""
      workLocation:"",
      department:"",
      designation:""
    });

   const [workLocation, setWorkLocation] = useState([])
   const [department, setDepartment] = useState([])
   const [designation, setDesignation] = useState([])

  const handleSubmit = () => {
    closeDrawer();
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
  ];
  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Create Payroll</DrawerHeader>
          <DrawerBody>
            <form>
            <div className='row '>
            <legend style={{ fontSize: 'Large' }}  className='sub-headers'>Basic Information</legend>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='First name' name='firstName'/>
                  </div>
                  <FormLabel className="small-label ps-3">First Name </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='last name' name='firstName'/>
                  </div>
                  <FormLabel className="small-label ps-3">Last Name </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Employee ID' name='employeeid'/>
                  </div>
                  <FormLabel className="small-label ps-3">Employee ID </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='email' style={{ outline: "none", border: "none" }} placeholder='Email' name='email'/>
                  </div>
                  <FormLabel className="small-label ps-3">Email </FormLabel>
                </div>
              </div>
              <div className='row '>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='workLocation' options={workLocation} defaultValue={workLocation.find((item)=>(item.value === formData?.workLocation))}  onChange={(option) => { setFormData(prevFormData => ({...prevFormData,workLocation:option.value }))}} styles={customStyle} />
                  <FormLabel className="small-label ps-3">Work Location</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='designation' options={designation} defaultValue={designation.find((item)=>(item.value === formData?.designation))}  onChange={(option) => { setFormData(prevFormData => ({...prevFormData,designation:option.value }))}} styles={customStyle} />
                  <FormLabel className="small-label ps-3">Designation</FormLabel>
                </div>
              </div>
              <div className='row '>
              <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <Select name='department' options={department} defaultValue={department.find((item)=>(item.value === formData?.department))}  onChange={(option) => { setFormData(prevFormData => ({...prevFormData,department:option.value }))}} styles={customStyle} />
                  <FormLabel className="small-label ps-3">Department</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                <div className='search-by-title'>
                  <select className=' rounded' type='text' placeholder="" style={{ width: '100%' ,outline:'none'}}   >
                      <option value={'male'} >Male</option>
                      <option value={'female'} >Female</option>
                    </select>
                  </div>
                  <FormLabel className="small-label ps-3">Gender </FormLabel>
                </div>
              </div>
              <div className='row '>
              <legend style={{ fontSize: 'Large' }}  className='sub-headers'>Personal Information</legend>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='email' style={{ outline: "none", border: "none" }} placeholder='Email' name='personalemail'/>
                  </div>
                  <FormLabel className="small-label ps-3">Personal Email </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Mobile Number' name='mobilenumber'/>
                  </div>
                  <FormLabel className="small-label ps-3">Mobile Number </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='date' style={{ outline: "none", border: "none" }} placeholder='DOB' name='dateofbirth'/>
                  </div>
                  <FormLabel className="small-label ps-3">Date Of Birth </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Age' name='age'/>
                  </div>
                  <FormLabel className="small-label ps-3">Age </FormLabel>
                </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='' name='fathername'/>
                  </div>
                  <FormLabel className="small-label ps-3">Father's Name </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Pan' name='pan'/>
                  </div>
                  <FormLabel className="small-label ps-3">PAN </FormLabel>
                </div>
              </div>
              <fieldset>
                  <div className='row'>
                  <legend style={{ fontSize: 'Large' }}  className='sub-headers'>Address Information</legend>
                    <div className='col-lg-8 col-md-4 col-sm-12 mb-2'>
                      <input className='form-control input-field' type='text' placeholder='street' name="street" value ={formData?.street}  onChange={handleChange} />
                      <FormLabel className="small-label ps-3">Street</FormLabel>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                      <input className='form-control input-field' type='text' placeholder='city' name="city" value ={formData?.city}  onChange={handleChange}  />
                      <FormLabel className="small-label ps-3">City</FormLabel>
                    </div>

                    <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                      <input className='form-control input-field' type='text' placeholder='state' name="state" value ={formData?.state}  onChange={handleChange} />
                      <FormLabel className="small-label ps-3">State</FormLabel>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                      <input className='form-control input-field' type='text' placeholder='pinCode' name="pinCode" value ={formData?.pinCode}  onChange={handleChange}  />
                      <FormLabel className="small-label ps-3">PinCode</FormLabel>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                      <select className='form-select input-field' name="country"  value ={formData?.country}  onChange={handleChange}  >
                        <option value="">Select Country</option>
                        {countries?.map((country, index) => (
                          <option key={index} value={country}>
                            {country}
                          </option>
                        ))}
                      </select>
                      <FormLabel className="small-label ps-3">Country</FormLabel>
                    </div>

                  </div>
                </fieldset>
                <div className='row '>
                <legend style={{ fontSize: 'Large' }}  className='sub-headers'>Salary Information</legend>
                <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Monthly Amount' name='monthlyamount'/>
                  </div>
                  <FormLabel className="small-label ps-3">Monthly Amount </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Annual Amount' name='annualamount'/>
                  </div>
                  <FormLabel className="small-label ps-3">Annual Amount </FormLabel>
                </div>
              </div>
              <div className='row '>
              <legend style={{ fontSize: 'Large' }}  className='sub-headers'>Payment Information</legend>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Account Holder Name' name='accountholdername'/>
                  </div>
                  <FormLabel className="small-label ps-3">Account Holder Name </FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Bank Name' name='bankname'/>
                  </div>
                  <FormLabel className="small-label ps-3">Bank Name </FormLabel>
                </div>
              </div>
              </div>
              <div className='row '>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='number' style={{ outline: "none", border: "none" }} placeholder='Account Number' name='accountnumber'/>
                  </div>
                  <FormLabel className="small-label ps-3">Account Number</FormLabel>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className='search-by-title'>
                    <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='IFSC' name='ifsc'/>
                  </div>
                  <FormLabel className="small-label ps-3"> IFSC Code</FormLabel>
                </div>
              </div>
              <div className='row'>
                <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                  <div className=''>
                    <div className="row mt-2">
                    <div className="col-4"><FormLabel className="small-label ps-3">Account Type</FormLabel></div>
                      <div className="col-4">
                  <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                  <label className="form-check-label ps-3" for="exampleRadios1">Current</label></div>
                  <div className="col-4">
                  <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" checked />
                  <label className="form-check-label ps-3" for="exampleRadios1">Savings</label>
                  </div>
                  </div>
                  </div>
                  </div>
                  </div>
            </form>
          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }}>
            <div className='gap-3 d-flex'>
              <button variant='outline' className='cancel-button' mr={3} onClick={handleOnClose}>
                Cancel
              </button>
              <button className='create-button' onClick={handleSubmit}>Submit</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default Payroll;